<template>
    <div>
        <b-button class="change-button" @click="showModal = true">
            {{ $t('button.createUser') }}
        </b-button>

        <b-modal
            v-model="showModal"
            class="create-user-modal-window"
            centered
            :title="$t('title.userCreation')"
            hide-footer
            @hidden="resetForm"
        >
            <ValidationObserver ref="creationObserver" v-slot="{ valid }">
                <b-form @submit.stop.prevent="handleSubmit">
                    <div>
                        <b-form-checkbox v-model="isTeacher" class="is-teacher-checkbox" switch>
                            {{ $t('title.teacherRegister') }}
                        </b-form-checkbox>

                        <b-form-checkbox v-model="passwordCreation" class="is-teacher-checkbox mb-3" switch>
                            {{ $t('title.passwordCreation') }}
                        </b-form-checkbox>

                        <v-input
                            type="text"
                            ind="name"
                            v-model="form.name"
                            rules="required"
                            :placeholder="$t('placeholder.name')"
                            autocomplete="off"
                        />

                        <v-input
                            type="text"
                            ind="surname"
                            v-model="form.surname"
                            rules="required"
                            :placeholder="$t('placeholder.surname')"
                            autocomplete="off"
                        />

                        <v-input
                            ind="mail"
                            type="text"
                            v-model="form.mail"
                            required
                            autocomplete="off"
                            rules="required|email|emailNotExists"
                            :placeholder="$t('placeholder.email')"
                        />

                        <v-input
                            ind="password"
                            type="text"
                            v-model="form.password"
                            :placeholder="$t('placeholder.password')"
                            v-if="passwordCreation"
                            :rules="{required: true, min: 6}"
                            autocomplete="off"
                        />
                    </div>
                    <div v-if="isTeacher">
                        <v-input
                            type="text"
                            ind="work.place"
                            v-model="form.work"
                            rules="required"
                            :placeholder="$t('placeholder.work')"
                            autocomplete="off"
                        />

                        <v-input
                            type="text"
                            ind="work.position"
                            v-model="form.position"
                            rules="required"
                            :placeholder="$t('placeholder.position')"
                            autocomplete="off"
                        />

                        <v-input
                            type="text"
                            ind="phone"
                            v-model="form.phone"
                            rules="required|phone"
                            :placeholder="$t('placeholder.phone')"
                            autocomplete="off"
                        />

                        <b-form-textarea id="comment" v-model="form.comment" rows="3" :placeholder="$t('placeholder.comment')" class="mb-3" />
                    </div>

                    <div class="d-flex justify-content-end">
                        <b-button type="submit" variant="primary" class="ml-2" :disabled="!valid">
                            {{ $t('button.save') }}
                        </b-button>
                    </div>
                </b-form>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
    import api from '@/api';
    import VInput from './VInput.vue';

    export default {
        name: 'CreateUser',

        components: { VInput },

        data() {
            return {
                showModal: false,
                isTeacher: false,
                passwordCreation: false,
                form: {
                    name: '',
                    surname: '',
                    password: '',
                    mail: '',
                    vkId: '',
                    work: '',
                    position: '',
                    phone: '',
                    comment: ''
                }
            };
        },

        methods: {
            async handleSubmit() {
                let valid = this.$refs.creationObserver.validate();

                if (!valid)
                    return;

                let type = this.isTeacher ? this.$defines.SERVICE_ACCOUNT_TYPES.TEACHER : this.$defines.SERVICE_ACCOUNT_TYPES.USER;

                this.form = Object.fromEntries(Object.entries(this.form).map(([ k, v ]) => [ k, v === '' ? undefined : v ]));

                let response = await api.post(
                    'app/registration/register',
                    {
                        type,
                        ...this.form,
                        acceptedMailing: true,
                        createdManually: true
                    }
                );

                if (!response)
                    return;

                this.$toast.success(this.$t('toast.userCreated'), '', { position: 'topRight' });

                this.$emit('userCreated');

                this.showModal = false;
            },

            resetForm() {
                this.showModal = false;
                this.isTeacher = false;

                this.form = {
                    name: '',
                    surname: '',
                    password: '',
                    mail: '',
                    vkId: '',
                    work: '',
                    position: '',
                    phone: '',
                    comment: ''
                };
            }
        }
    };
</script>

<style scoped>
    .create-user-modal-window {
        max-width: 450px !important;
        justify-content: center;
        align-items: center;
    }

    .is-teacher-checkbox ::before {
        background: none;
    }

    .is-teacher-checkbox ::before :checked {
        background: white !important;
    }

    .is-teacher-checkbox {
        margin-left: auto;
        display: flex;
        align-items: center;
        margin-bottom: 0.5rem;
    }

    .modal-item {
        margin-bottom: 0.5rem;
    }

    /deep/ .custom-control-input:checked ~ .custom-control-label::before {
        background-color: rgb(51, 141, 201) !important;
        border-color: rgb(51, 141, 201) !important;
    }

    /deep/ .btn-primary.disabled, .btn-primary:disabled {
        background-color: #6c757d;
        border-color: #6c757d;
        opacity: 1;
    }

    /deep/ .input-group:not(.has-validation) > .form-control:not(:last-child) {
        border-top-right-radius: 0.25rem !important;
        border-bottom-right-radius: 0.25rem !important;
    }
</style>
